<template>
   <div class="card card-frame mt-1 mb-5 h-auto w-100">
      <div class="card-body h-auto">
         <div class="row mx-3">
            <div id="resultcard-title" class="col-12">Detalle de la consulta</div>
            <div id="resultcard-subtitle" class="col-12">Revisa los informes o reportes de tu interés.</div>
         </div>
         <div class="row justify-content-start card-form-row py-3 my-3 mx-3">
            <div class="col-9">
               <table>
                  <tr>
                     <td><img class="pb-1 px-2" src="../assets/images/campana_detalle_user_icon.svg" /></td>
                     <td>
                        <div class="resultcard-subject my-1"><span style="font-weight: 700">Entidad:</span> {{ resultData.NOMBREESTADO }}</div>
                        <div class="resultcard-subject my-1"><span style="font-weight: 700">Actor Político:</span> {{ resultData.NOMBRESO }}</div>
                        <div class="resultcard-subject my-1">
                           <span style="font-weight: 700">Comité del Partido:</span> {{ resultData.COMITEPARTIDO }}
                        </div>
                     </td>
                  </tr>
               </table>
            </div>
            <div class="col-3 align-self-center" v-on:click.prevent="copyToClipboard">
               <span class="resultcard-link" style="cursor: pointer" v-tooltip.right="linkLabel"
                  ><i class="pi pi-link" style="font-size: 1.5rem"></i>Enlace para compartir</span
               >
            </div>
         </div>
         <div class="row justify-content-start card-form-row py-3 my-3 mx-3 px-2">
            <div class="col-12">
               <div class="row">
                  <span class="resultcard-inflist-header col-12">Lista de informes presentados</span>
               </div>
               <div class="row">
                  <div class="col-6">
                     <table>
                        <tr>
                           <td class="align-top"><i class="pi pi-calendar resultcard-inflist-subheader" style="font-size: 2rem"></i></td>
                           <td class="px-2">
                              <span class="resultcard-inflist-subheader">Periodo del informe: </span>
                              <p class="resultcard-inflist-text">
                                 La ley establece que los informes trimestrales deberán de presentarse dentro de los 30 días siguientes a la
                                 conclusión del trimestre correspondiente, mientras que el Informe Anual deberá presentarse dentro de los 60 días
                                 siguientes a la conclusión del ejercicio que se reporte.
                              </p>
                           </td>
                        </tr>
                        <tr>
                           <td class="align-top"><i class="pi pi-folder resultcard-inflist-subheader" style="font-size: 2rem"></i></td>
                           <td class="px-2">
                              <span class="resultcard-inflist-subheader">Informe normal: </span>
                              <p class="resultcard-inflist-text">
                                 Documento que contiene el origen y destino de los recursos que se utilizan en el proceso ordinario.
                              </p>
                           </td>
                        </tr>
                     </table>
                  </div>
                  <div class="col-6">
                     <table>
                        <tr>
                           <td class="align-top"><i class="pi pi-cog resultcard-inflist-subheader" style="font-size: 2rem"></i></td>
                           <td class="px-2">
                              <span class="resultcard-inflist-subheader">Informe de Corrección: </span>
                              <p class="resultcard-inflist-text">
                                 Documento que se presenta cuando el Informe Normal contiene inconsistencias u observaciones detectadas por la
                                 autoridad fiscalizadora y que se conforma por dos periodos de corrección.
                              </p>
                           </td>
                        </tr>
                     </table>
                  </div>
               </div>
               <div class="row">
                  <div class="col-12">
                     <table class="table table-rounded table-responsive">
                        <thead>
                           <tr class="tr-rounded">
                              <th class="th-left-rounded">Periodo</th>
                              <th>Tipo de informe</th>
                              <th>Informe presentado</th>
                              <th class="th-right-rounded">Reporte de operaciones</th>
                           </tr>
                        </thead>
                        <tbody class="resultcard-table-cell-text">
                           <tr v-for="(informe, index) in informes" :key="index">
                              <td class="text-center">{{ informe.periodo }}</td>
                              <td class="text-start">{{ informe.tipo }}</td>
                              <td class="text-center">
                                 <img
                                    v-if="informe.informePresentado"
                                    src="../assets/images/pdf.svg"
                                    v-on:click="showPdf(informe.informePresentado)"
                                    class="pointer"
                                 />
                                 <span v-else>--</span>
                              </td>
                              <td class="text-center">
                                 <a v-if="informe.informePresentadoXls" :href="informe.informePresentadoXls" download>
                                    <img src="../assets/images/xls.svg" />
                                 </a>
                                 <span v-else>--</span>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
         <div class="row justify-content-start card-form-row py-3 my-3 mx-3 px-2">
            <div class="col-12">
               <div class="row">
                  <span class="resultcard-inflist-header col-12">Lista de informes anual presentado</span>
               </div>
               <div class="row">
                  <div class="col-12">
                     <table class="table table-rounded table-responsive">
                        <thead>
                           <tr class="tr-rounded">
                              <th class="th-left-rounded">Periodo</th>
                              <th>Tipo de informe</th>
                              <th>Informe presentado</th>
                              <th class="th-right-rounded">Reporte de operaciones</th>
                           </tr>
                        </thead>
                        <tbody class="resultcard-table-cell-text">
                           <tr v-for="(informe, index) in informesAnuales" :key="index">
                              <td class="text-center">{{ informe.periodo }}</td>
                              <td class="text-start">{{ informe.tipo }}</td>
                              <td class="text-center">
                                 <img
                                    v-if="informe.informePresentado"
                                    src="../assets/images/pdf.svg"
                                    v-on:click="showPdf(informe.informePresentado)"
                                    class="pointer"
                                 />
                                 <span v-else>--</span>
                              </td>
                              <td class="text-center">
                                 <a v-if="informe.informePresentadoXls" :href="informe.informePresentadoXls" download>
                                    <img src="../assets/images/xls.svg" />
                                 </a>
                                 <span v-else>--</span>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
         <div class="row justify-content-start card-form-row py-3 my-3 mx-3 px-2">
            <div class="col-12">
               <div class="row">
                  <div class="col-12">
                     <span class="resultcard-inflist-header">Lista de reportes</span>
                  </div>
                  <div class="col-12">
                     <table class="table table-rounded table-responsive my-2">
                        <thead>
                           <tr class="tr-rounded">
                              <th class="th-left-rounded">Tipo de información</th>
                              <th>Descarga</th>
                              <th class="th-right-rounded">Fecha de corte</th>
                           </tr>
                        </thead>
                        <tbody class="resultcard-table-cell-text">
                           <tr v-for="(reporte, index) in reportes" :key="index">
                              <td class="text-start">{{ reporte.informacionTipo }}</td>
                              <td class="text-start">
                                 <img
                                    v-if="reporte.descargaPdf"
                                    src="../assets/images/pdf.svg"
                                    v-on:click="showPdf(reporte.descargaPdf)"
                                    class="pointer"
                                 />
                                 <a v-if="reporte.descargaXls" :href="reporte.descargaXls" download>
                                    <img src="../assets/images/xls.svg" />
                                 </a>
                                 <span v-if="!reporte.descargaPdf && !reporte.descargaXls">No existen datos para este reporte</span>
                              </td>
                              <td class="text-center">
                                 <span v-if="reporte.fechaCorte">{{ reporte.fechaCorte }}</span>
                                 <span v-else>--</span>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <PrimeDialog v-model:visible="displayPdfViewer" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }" :modal="true">
      <template v-if="displayPdfViewer"><PdfObject :pdfLink="pdf"></PdfObject></template>
   </PrimeDialog>
</template>

<script setup>
import { defineProps, defineExpose, onMounted, ref } from "vue";
import FiltersOrdinarioDataService from "@/service/FiltersOrdinarioDataService";
import UtilService from "@/service/UtilService";
import { useToast } from "primevue/usetoast";
import PdfObject from "./PdfObject.vue";

const displayPdfViewer = ref(false);
const informes = ref([]);
const informesAnuales = ref([]);
const link = ref("");
const linkLabel = ref("Clic para copiar enlace");
const pdf = ref();
const reportes = ref([]);

const toast = useToast();

const props = defineProps({
   resultData: Object,
   idProcesoGeneral: Number,
   secondary: Boolean,
   addAjax: Function,
   removeAjax: Function,
   load500Error: Function,
});

onMounted(() => {
   getDetalle(props.resultData, props.idProcesoGeneral);
});

const getDetalle = (contabilidad, anio) => {
   props.addAjax();
   FiltersOrdinarioDataService.getDetalle(props.secondary, contabilidad, anio)
      .then((res) => {
         informes.value = res.data.body.informes;
         informesAnuales.value = res.data.body.informesAnuales;
         reportes.value = res.data.body.reportes;
         link.value = res.data.body.link;
         props.removeAjax();
      })
      .catch((err) => {
         props.removeAjax();
         console.log(err);
         props.load500Error(err);
      });
};

const copyToClipboard = () => {
   UtilService.copyDetalleLink(link.value);
   showInfo();
};

const showInfo = () => {
   //console.log(toast);
   toast.add({ severity: "info", summary: "Enlace para compartir", detail: "Enlace copiado", life: 3000 });
};

const showPdf = (pdfParam) => {
   pdf.value = pdfParam;
   //console.log(pdf);
   displayPdfViewer.value = true;
};

defineExpose({
   getDetalle,
});
</script>
